// react
import { useState } from 'react';

// components
import CalendarSteps from './components/CalendarSteps/CalendarSteps';
import TimeSlotActions from './components/TimeSlotActions/TimeSlotActions';
import { Popover } from 'components/mrp/components/Popover';
import { Typography } from '@mui/material';
import CalendarViewStateToggle from './components/CalendarViewStateToggle/CalendarViewStateToggle';

// hooks
import { useTranslation } from 'react-i18next';

// styles
import {
  Container,
  ContentContainer,
  Header,
  Section,
  ViewOptionsButton
} from './HeaderViewOptions.styles';

export const HeaderViewOptions = () => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp' });

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <Popover
      id="header-view-options-popover"
      open={isPopoverOpen}
      showBackdrop={false}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      onClose={() => setIsPopoverOpen(false)}
      component={
        <Container>
          <Header>
            <Typography variant="subtitle1">{t('displayOptions')}</Typography>
          </Header>

          <ContentContainer columnCount={2}>
            <Section>
              <Typography variant="subtitle2">{t('timeFrameSteps')}</Typography>
              <CalendarSteps />
            </Section>

            <Section>
              <Typography variant="subtitle2">{t('timeFrame')}</Typography>
              <TimeSlotActions />
            </Section>
          </ContentContainer>

          <ContentContainer>
            <Section>
              <Typography variant="subtitle2">{t('viewState')}</Typography>
              <CalendarViewStateToggle
                onAnyAction={() => setIsPopoverOpen(false)}
              />
            </Section>
          </ContentContainer>
        </Container>
      }
    >
      <ViewOptionsButton
        onClick={() => setIsPopoverOpen(true)}
        type="sliders"
        variant="outlined"
      />
    </Popover>
  );
};
